import { render, staticRenderFns } from "./Dashboardtoplistas.vue?vue&type=template&id=18dec462"
import script from "./Dashboardtoplistas.vue?vue&type=script&lang=js"
export * from "./Dashboardtoplistas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports